import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="font-heading text-xl font-semibold text-foreground-900 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          淫乱小镇
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                (cat.slug === 'all' && location.pathname === '/') ||
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ml-2 ${
              location.pathname === '/about'
                ? 'bg-primary-100 text-primary-700 font-medium'
                : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              className={`px-3 py-2.5 text-sm rounded-lg transition-colors cursor-pointer ${
                (cat.slug === 'all' && location.pathname === '/') ||
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-100 text-primary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-3 py-2.5 text-sm rounded-lg transition-colors cursor-pointer ${
              location.pathname === '/about'
                ? 'bg-primary-100 text-primary-700 font-medium'
                : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}